import { useState } from 'react'
import { FunctionsList, ItemDetails, StyledSearchInput } from 'components'
import { Box, styled, Typography } from '@mui/material'
import { Pagination, ThresholdSearchInput } from 'packages/eid-ui'
import { useDebounce, useIsSmallScreen } from 'packages/core'
import { useAzureRoleGlobalSensitiveFunctions } from 'hooks'
import { useTranslation } from 'react-i18next'

const PaddedDiv = styled('div')({
    padding: '0 31px',
})

const take = 10

export const GlobalSensitiveFunctions = ({
    azureRbacRole,
    locationId,
}: any) => {
    const { t } = useTranslation()

    const isSmallScreen = useIsSmallScreen()

    const [page, setPage] = useState(1)
    const [perPageItems, setPerPageItems] = useState(take)
    const [searchKey, setSearchKey] = useState('')

    const handlePageChange = (_: any, value: any) => {
        setPage(value)
    }
    const handlePageSelection = (value: any) => {
        setPage(value)
    }
    const handleItemsPerPageChange = (value: any) => {
        setPage(1)
        setPerPageItems(value)
    }

    const handleSearchChange = (value: any) => {
        setPage(1)
        setSearchKey(value)
    }

    const { data } = useAzureRoleGlobalSensitiveFunctions(
        azureRbacRole.id,
        (page - 1) * perPageItems,
        perPageItems,
        locationId,
        searchKey && encodeURIComponent(searchKey),
    )

    const globalSensitiveFunctions = data ? data.data : undefined

    const globalFunctionsLoading = !Boolean(data)

    const numberOfPages = data ? Math.ceil(data.totalCount / perPageItems) : 0

    return (
        <>
            <PaddedDiv
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '16px 31px',
                }}
            >
                <Box width="50%">
                    <Typography
                        style={{
                            fontSize: '12px',
                            lineHeight: 1.33,
                            color: '#9b9b9b',
                            wordBreak: 'break-word',
                            textTransform: 'uppercase',
                            minWidth: '80px',
                        }}
                    >
                        {t('Common_GlobalFunctionalAccess')}
                    </Typography>
                </Box>

                <Box width={!isSmallScreen ? '308px' : '50%'} minWidth="130px">
                    <ThresholdSearchInput
                        placeholder={'Common_Search'}
                        handleSearch={handleSearchChange}
                    />
                </Box>
            </PaddedDiv>

            {globalFunctionsLoading ? (
                <ItemDetails.AttributesContainer>
                    <PaddedDiv>
                        <ItemDetails.AttributesLoader />
                    </PaddedDiv>
                </ItemDetails.AttributesContainer>
            ) : (
                <>
                    {globalSensitiveFunctions && (
                        <>
                            <Box overflow="auto">
                                <FunctionsList
                                    data={globalSensitiveFunctions}
                                    loading={globalFunctionsLoading}
                                />

                                <Box
                                    padding={
                                        !isSmallScreen ? '20px 32px' : '16px'
                                    }
                                    display="flex"
                                    alignItems="center"
                                    justifyContent={
                                        !isSmallScreen ? 'flex-start' : 'center'
                                    }
                                >
                                    <Pagination
                                        count={numberOfPages}
                                        size={
                                            !isSmallScreen ? 'large' : 'small'
                                        }
                                        page={page}
                                        onChange={handlePageChange}
                                        totalCount={data?.totalCount}
                                        onPageSelection={handlePageSelection}
                                        itemsPerPage={perPageItems}
                                        onItemsPerPageChange={
                                            handleItemsPerPageChange
                                        }
                                        showPageSelection={true}
                                        showItemsPerPageSelection
                                        showCountStat
                                    />
                                </Box>
                            </Box>
                        </>
                    )}
                </>
            )}
        </>
    )
}
